import { createConfig, cookieStorage, http, createStorage } from 'wagmi';
import { base, baseSepolia, sepolia } from 'wagmi/chains';
import { walletConnect } from 'wagmi/connectors';

import { getActiveNetwork } from '@/lib/network/getActiveNetwork';
import { C_NETWORK_RPC_URLS } from '@/ts/constants/C_NETWORK_RPC_URLS';
import { E_Network } from '@/ts/enums/E_Network';

import type { Chain } from 'wagmi/chains';

const C_NETWORK_CHAIN_MAP: Record<E_Network, Chain> = {
  [E_Network.BASE]: base,
  [E_Network.BASE_SEPOLIA]: baseSepolia,
  [E_Network.SEPOLIA]: sepolia
};

const C_NETWORK_RPC_ENV_OVERRIDES: Partial<
  Record<E_Network, string | undefined>
> = {
  [E_Network.BASE]: process.env.NEXT_PUBLIC_RPC_BASE,
  [E_Network.BASE_SEPOLIA]: process.env.NEXT_PUBLIC_RPC_BASE_SEPOLIA,
  [E_Network.SEPOLIA]: process.env.NEXT_PUBLIC_RPC_SEPOLIA
};

const activeNetwork = getActiveNetwork();
const activeChain = C_NETWORK_CHAIN_MAP[activeNetwork];

const activeRpcUrl =
  C_NETWORK_RPC_ENV_OVERRIDES[activeNetwork] ??
  C_NETWORK_RPC_URLS[activeNetwork];
export function createWagmiConfig() {
  const isServer = typeof window === 'undefined';

  return createConfig({
    chains: [activeChain],

    ssr: true,
    storage: createStorage({
      storage: cookieStorage // Use cookie storage for persistence
    }),
    transports: {
      [activeChain.id]: http(activeRpcUrl)
    },
    connectors: isServer
      ? []
      : [
          walletConnect({
            projectId: process.env.NEXT_PUBLIC_WALLETCONNECT_PROJECT_ID!,
            metadata: {
              name: 'TrenDex.One',
              description: 'Sign in and predict on TrenDex.One',
              url: window?.location?.origin,
              icons: [
                `${window?.location?.origin}/assets/icons/trendex-small.svg`
              ]
            },
            showQrModal: true
          })
        ]
  });
}
